import stimulus from '../lib/stimulus-instance'
import Toggler from './controllers/toggler-controller'
// no promotion lotteries are running now
// instead of implementing dynamic logic to load extra js, css and cache sweepers. I decided to just comment out.
// views/layout/application.html.slim, assets/stylesheets/_layout.scss, assets/js_modules/frontend/controllers.js
// import WheelOfFortuneController from '../../../components/wheel_of_fortune_component/wheel-of-fortune-controller'
import FormController from 'controllers/form-controller'

stimulus.register('toggler', Toggler)
stimulus.register('form', FormController)
// stimulus.register('wheel-of-fortune', WheelOfFortuneController)
